import initialState from '../../data/stash';
import ActionTypes from '../constants/action-types';

const stashReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_STASH:
            return {
                ...state,
                ...action.payload
            };
        case ActionTypes.SET_ACTIVE_ALBUM:
            return {
                ...state,
                activeAlbum: action.payload
            };
        case ActionTypes.SET_STASH_MEDIAS:
            return {
                ...state,
                medias: action.payload
            };

        case ActionTypes.SET_STASH_HASMORE:
            return {
                ...state,
                hasMore: action.payload
            };

        case ActionTypes.SET_STASH_GET_INFORMATION:
            return {
                ...state,
                mediaFilesToGetInformation: action.payload
            };

        case ActionTypes.SET_STASH_FILTER:
            return {
                ...state,
                filter: action.payload
            };

        case ActionTypes.SET_STASH_ALBUMS:
            return {
                ...state,
                albums: action.payload
            };

        case ActionTypes.SET_STASH_BUSY:
            return {
                ...state,
                busy: action.payload
            };

        case ActionTypes.SET_STASH_SELECTED:
            return {
                ...state,
                stashSelected: action.payload
            };

        case ActionTypes.SET_STASH_SHOW:
            return {
                ...state,
                show: action.payload
            };

        case ActionTypes.SET_STASH_SIDEBAR:
            return {
                ...state,
                stashSidebar: action.payload
            };

        case ActionTypes.SET_STASH_TO_GET_INFO:
            return {
                ...state,
                mediaFilesToGetInformation: action.payload
            };

        case ActionTypes.SET_STASH_TAB_SELECTED:
            return {
                ...state,
                tabSelected: action.payload
            };

        case ActionTypes.SET_ALBUM_ACTION:
            return {
                ...state,
                albumAction: action.payload
            };
        case ActionTypes.SET_NEW_ALBUM_FORM:
            return {
                ...state,
                showAlbumModal: action.payload
            };

        case ActionTypes.SET_ADD_MEDIA_TO_ALBUM:
            return {
                ...state,
                addMediaToAlbum: action.payload
            };

        case ActionTypes.SET_STASH_ALBUM_MEDIAS:
            const albumMedias = {
                ...state.activeAlbum,
                medias: action.payload
            };
            return {
                ...state,
                activeAlbum: albumMedias
            };

        case ActionTypes.SET_STASH_ACTIVE_ALBUM:
            return {
                ...state,
                activeAlbum: action.payload
            };

        case ActionTypes.SET_ORDER_MODAL:
            return {
                ...state,
                orderModal: action.payload
            };

        case ActionTypes.SET_STASH_ALBUM_GET_INFORMATION:
            return {
                ...state,
                albumGetMediaInfo: action.payload
            };

        case ActionTypes.SET_STASH_ACTIVE_ALBUM_MEDIAS:
            const payload = {
                ...state.activeAlbum,
                medias: action.payload
            };

            return {
                ...state,
                activeAlbum: payload
            };

        case ActionTypes.SET_STASH_MEDIA_SENT:
            return {
                ...state,
                mediaSent: action.payload
            };

        case ActionTypes.SET_STASH_MEDIA_SOLD:
            return {
                ...state,
                mediaSold: action.payload
            };

        case ActionTypes.SET_TEMP_STASH_SELECTED:
            return {
                ...state,
                tempSelected: action.payload
            };

        case ActionTypes.PREPEND_MEDIA_TO_MEDIAS:
            let tmpMedias = [...state.medias];
            tmpMedias.unshift(action.payload);

            return {
                ...state,
                medias: [...tmpMedias]
            };

        case ActionTypes.RESET_STASH_MEDIAS:
            return {
                ...state,
                medias: [],
                reset: true,
            };

        case ActionTypes.SET_STASH_ALBUM_LIST_SCROLL_POSITION:
            return {
                ...state,
                albumListScrollTopPosition: action.payload
            };

        case ActionTypes.SET_STASH_RESET:
            return {
                ...state,
                reset: action.payload
            };

        case ActionTypes.SET_STASH_TYPE:
            return {
                ...state,
                filterType: action.payload
            };

        case ActionTypes.SET_STASH_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ActionTypes.SET_STASH_FILTER_TO_DATE:
            return {
                ...state,
                filterToDate: action.payload
            };

        case ActionTypes.SET_STASH_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };

        default: return state;
    }
};

export default stashReducer;
